import React from "react";

import data from "../../../../data/Home-page/content";
import Reveal from "../../../../components/Reveal";
import SectionDivider from "../../../../components/SectionDivider";
import logo from "../../../../assets/images/sutramay-logo.svg";
import { useInquiryModal } from "../../../../context/InquiryModalContext";

export default function Banner() {
  const { title, tagline, description } = data.hero;
  const { openInquiry } = useInquiryModal();

  return (
    <>
      <div className="relative z-10 flex flex-col items-center px-6 max-w-4xl text-center">
        <Reveal>
  <div className="flex flex-col items-center justify-center">
    {/* Logo */}
    <img
      src={logo}
      alt="Sutramay Logo"
      className="h-32 sm:h-36 md:h-44 w-auto mb-6"
    />

    {/* Title */}
    <h1
      className="
        font-heading
        font-semibold
        uppercase
        tracking-[0.06em]
        text-maroon-800
        text-4xl
        sm:text-5xl
        text-center
      "
    >
      {title.split(" ").map((word) => (
        <span key={word} className="block">
          {word}
        </span>
      ))}
    </h1>
  </div>
</Reveal>

        <Reveal delay={150}>
          <p className="font-accent italic text-maroon-600 text-sm sm:text-base mt-4">
            {tagline}
          </p>
        </Reveal>

        <Reveal delay={300}>
          <div className="mt-6">
            <SectionDivider />
          </div>
        </Reveal>

        <Reveal delay={450}>
          <p className="font-body text-maroon-900/90 text-base sm:text-lg mt-4 leading-relaxed">
            {description}
          </p>
        </Reveal>

        <Reveal delay={600}>
          <div className="mt-10 flex flex-col sm:flex-row items-center gap-5">
            <button
              type="button"
              onClick={openInquiry}
              className="inline-block rounded-sm border border-maroon-700/60 text-maroon-700 font-accent tracking-[0.15em] uppercase text-xs px-10 py-4 hover:border-gold-500 hover:text-gold-700 transition-colors duration-500"
            >
              Enquire Now
            </button>
          </div>
        </Reveal>
      </div>
    </>
  );
}
